import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getCurrencySymbol } from "@/utils/formatters";
export const ContractPricingDisplay = ({ pricing })=>{
    if (pricing?.type === "marketplace") {
        return /*#__PURE__*/ _jsxs("div", {
            className: "space-y-1",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-xs font-medium text-gray-900",
                    children: "AWS Marketplace Contract"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-xs text-gray-600",
                    children: "Contact AWS Marketplace for pricing details"
                }),
                pricing.includedQuota > 0 && /*#__PURE__*/ _jsxs("div", {
                    className: "text-xs text-gray-500",
                    children: [
                        "(",
                        pricing.includedQuota,
                        " ",
                        pricing.quotaUnit,
                        " included)"
                    ]
                })
            ]
        });
    }
    if (pricing?.type === "tiered") {
        return /*#__PURE__*/ _jsx("div", {
            className: "space-y-1",
            children: pricing.tiers.map((tier, index)=>/*#__PURE__*/ _jsxs("div", {
                    className: "text-xs text-gray-900",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            className: "font-medium",
                            children: [
                                tier.tier,
                                ":"
                            ]
                        }),
                        tier.price !== undefined ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                " ",
                                getCurrencySymbol(pricing.currency),
                                tier.price,
                                "/mo"
                            ]
                        }) : null,
                        tier.range ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                " (",
                                tier.range,
                                ")"
                            ]
                        }) : null
                    ]
                }, `${tier.tier}-${tier.range}-${index}`))
        });
    }
    if (pricing?.type === "fixed" && pricing.price !== undefined) {
        return /*#__PURE__*/ _jsxs("span", {
            className: "text-sm font-medium text-gray-900",
            children: [
                getCurrencySymbol(pricing.currency),
                pricing.price,
                "/month"
            ]
        });
    }
    return /*#__PURE__*/ _jsx("span", {
        className: "text-sm text-gray-500",
        children: "Custom pricing"
    });
};
export default ContractPricingDisplay;
